import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export default function PageIntro({ eyebrow, title, description, number, action }) {
  return (
    <section className="page-intro" data-testid="page-intro">
      <div className="container page-intro-grid">
        <Reveal className="page-intro-copy">
          <span className="eyebrow"><span className="eyebrow-rule" />{eyebrow}</span>
          <h1>{title}</h1>
        </Reveal>
        <Reveal className="page-intro-side" delay={100}>
          <span className="page-intro-number">{number}</span>
          <p>{description}</p>
          {action && <Link className="text-link" to={action.href} data-testid={action.testId}>{action.label} <ArrowUpRight size={16} /></Link>}
        </Reveal>
      </div>
    </section>
  );
}
